import { useEffect, useRef, useState } from "react";

export function useScrollAnimation(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let singleObserver: IntersectionObserver | null = null;
    const el = ref.current;

    if (el) {
      singleObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              singleObserver?.unobserve(entry.target);
            }
          });
        },
        { threshold, rootMargin: "0px 0px -40px 0px" }
      );
      singleObserver.observe(el);
    }

    const classObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            classObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    const elements = document.querySelectorAll(".animate-on-scroll");
    elements.forEach((element) => classObserver.observe(element));

    return () => {
      singleObserver?.disconnect();
      classObserver.disconnect();
    };
  }, [threshold]);

  return { ref, isVisible };
}
